import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck";
import ConfirmationDialog from "../../../../components/customComponents/ConfirmationModal/index";
import {
  updateCredit,
  getUsersList,
} from "../../../../../app/redux/slices/app/issueCreditSlice";
import BillingHistoryLoader from "../../ManagePreference/BillingHistoryLoader.jsx";
import CustomSnackbar from "../../../../components/customComponents/CustomSnackbar/index";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "../../../../../features/components/customComponents/pagination.jsx";
import ModalComponent from "../../../../../features/components/customComponents/ModalComponent/ModalComponent.jsx";
import ResetuserPasswordbyAdmin from "./ResetuserPasswordbyAdmin";
const ManageUser = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [passwordResetModalopen, setPasswordresetModal] = useState(false);
  const [editData, setEditModalData] = useState({});
  const [clear, setModDataClear] = useState(false);

  const [filterParams, setfilterparams] = useState({
    email: "",
    phone: "",
    community: "",
    street_address: "",
    zip_code: "",
    service_type_code: "",
    page_number: 1,
    page_size: 10,
  });
  const [page, setPage] = useState({
    totalCount: 0,
    currentPage: 1,
    pageCount: 3,
    itemsPerPage: 10,
  });

  const dispatch = useDispatch();
  const [commonList, setCommonList] = useState([]);
  const [successMessage, setSuccesMessage] = useState({
    message: "",
    type: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const updateCreditSliceDetails = useSelector(
    (state) => state?.depositSlice?.updateCredit
  );
  const issueCreditdata = useSelector(
    (state) => state?.issueCreditSlice?.usersList
  );
  useEffect(() => {
    if (issueCreditdata?.data) {
      const updatedList =
        issueCreditdata?.data?.customer_details_responses?.map((item) => ({
          ...item,
          credit_amount: 0,
          credit_status: "not_initiated",
        }));
      setCommonList(updatedList);
      setPage({
        ...page,
        totalCount: issueCreditdata?.data?.total_records,
      });
    } else {
      setCommonList([]);
      setPage({
        ...page,
        totalCount: 0,
      });
    }
  }, [issueCreditdata]);
  useEffect(() => {
    setfilterparams({
      ...filterParams,
      page_number: page.currentPage,
      page_size: page.itemsPerPage,
    });
  }, [page.currentPage, page.itemsPerPage]);

  useEffect(() => {
    if (issueCreditdata?.data?.customer_details_responses?.length > 0) {
      LoadsearchUser();
    }
  }, [filterParams.page_number, filterParams.page_size]);

  const LoadsearchUser = async () => {
    dispatch(
      getUsersList({
        ...filterParams,
      })
    );
  };

  const clearform = () => {
    setfilterparams({
      email: "",
      phone: "",
      community: "",
      street_address: "",
      zip_code: "",
      service_type_code: "",
      page_number: 1,
      page_size: 10,
    });
    setCommonList([]);
  };
  const searchUser = () => {
    const {
      email,
      phone,
      community,
      street_address,
      zip_code,
      service_type_code,
    } = filterParams;

    const isAllEmpty =
      !email &&
      !phone &&
      !community &&
      !street_address &&
      !zip_code &&
      !service_type_code;

    if (isAllEmpty) {
      setSuccesMessage({
        message: "Please fill at least one filter field to search.",
        type: "Error",
      });
      setOpenSnackbar(true);
      return;
    }

    LoadsearchUser();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setfilterparams((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordModalOpen = (item) => {
    setEditModalData(item);

    setPasswordresetModal(true);
  };
  const onCloseModal = () => {
    setPasswordresetModal(false);
    setEditModalData({});
    setModDataClear(true);
  };

  const handleCreditSubmit = async () => {
    const creditItems = commonList?.filter((item) => item.credit_amount > 0);
    const updatedList = [...commonList];

    for (const item of creditItems) {
      const payload = {
        acct_no: item.account_no,
        credit_reason_cd: 101,
        credit_amount: Number(item?.credit_amount),
        comments: "Credit Adjustment",
      };

      try {
        const result = await dispatch(updateCredit(payload)).unwrap();
        if (result?.data?.data?.error_msg) {
          const index = updatedList?.findIndex(
            (i) =>
              i.account_no === item.account_no &&
              i.service_type_code === item.service_type_code
          );
          if (index !== -1) {
            updatedList[
              index
            ].credit_status = `Error:${result?.data?.data?.error_msg}`;
          }
        } else {
          const index = updatedList.findIndex(
            (i) =>
              i.account_no === item.account_no &&
              i.service_type_code === item.service_type_code
          );
          if (index !== -1) {
            updatedList[index].credit_status = `Success`;
          }
        }
      } catch (error) {
        console.error("Credit failed for account:", item.acct_no, error);
      }
    }
    setCommonList(updatedList);
  };
  const openDialog = () => {
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };
  const confirmAction = () => {
    handleCreditSubmit();
    closeDialog();
  };

  return (
    <>
      <ModalComponent
        openModal={passwordResetModalopen}
        onClose={onCloseModal}
        modalId="resetpass"
        islarge={true}
        mainheading="Reset password"
        modalContent={
          <ResetuserPasswordbyAdmin
            onClose={onCloseModal}
            editData={editData}
            clear={clear}
          />
        }
      />
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={successMessage?.type === "Error" ? "error" : "success"}
        message={successMessage.message}
        autoHideDuration={1500}
        handleClose={() => {
          setOpenSnackbar(false);
        }}
      />
      <ConfirmationDialog
        title="Confirm Action"
        open={dialogOpen}
        onClose={closeDialog}
        onConfirm={confirmAction}
        content={`Are you sure you want to credit ${
          commonList?.filter((item) => item.credit_amount > 0)?.length
        } accounts?`}
      />

      <div className="row min-h-100">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch border-0 p-0 rounded-0">
            <div className="card-header border-0 bg-custom-light search-filters py-3 rounded">
              <div className="col-12 d-flex justify-content-between align-items-center mb-2">
                <h4 className="text-dark-blue fw-600">Search User Account</h4>
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">Community</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Community"
                        name="community"
                        value={filterParams.community}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">Zipcode</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Zipcode"
                        name="zip_code"
                        value={filterParams.zip_code}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">Email</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Email"
                        name="email"
                        value={filterParams.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">Phone</label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Phone"
                        name="phone"
                        value={filterParams.phone}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">
                        Service Address
                      </label>{" "}
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Service Address"
                        name="street_address"
                        value={filterParams.street_address}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label className="searchform-inputlabel">
                        Select Service
                      </label>{" "}
                      <div className="d-flex gap-3 align-items-center">
                        {["FIBER", "VOIP", "TV", "GAS"].map((service) => (
                          <div
                            className="form-check form-check-inline"
                            key={service}
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="service_type_code"
                              id={service}
                              value={service}
                              checked={
                                filterParams.service_type_code === service
                              }
                              onChange={handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={service}
                            >
                              {service}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <button
                      style={{ marginTop: "20px", fontSize: "12px" }}
                      className="btn btn-custom electric_cobalt min-h-25px"
                      onClick={(e) => {
                        e.preventDefault();
                        searchUser();
                      }}
                      disabled={issueCreditdata.loader}
                    >
                      Search{" "}
                      {issueCreditdata?.loader ? (
                        <CircularProgress color="white" size={20} />
                      ) : (
                        <i className="fas fa-search"></i>
                      )}
                    </button>{" "}
                    &ensp;
                    <button
                      style={{ marginTop: "20px", fontSize: "12px" }}
                      className="btn btn-custom startlit_navy min-h-25px"
                      onClick={(e) => {
                        e.preventDefault();
                        clearform();
                      }}
                      disabled={issueCreditdata?.loader}
                    >
                      Clear <i className="fas fa-eraser"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body px-0">
              <div className="card-body-content">
                <div className="table-reponsive">
                  <table className="table ">
                    <thead>
                      <tr valign="middle">
                        <th>Sl no.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Acc No.</th>
                        <th>Address</th>
                        <th>Zip</th>
                        <th>Service type</th>
                        <th>Community</th>

                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!issueCreditdata.loader && commonList?.length === 0 && (
                        <tr>
                          <td colSpan="13" className="ndf">
                            No data found
                          </td>
                        </tr>
                      )}
                      {issueCreditdata?.loader && <BillingHistoryLoader />}
                      {!issueCreditdata?.loader &&
                        commonList?.length > 0 &&
                        commonList?.map((item, index) => (
                          <tr key={index} valign="middle">
                            <td className="text-blue">{index + 1}</td>
                            <td className="text-blue">{item.name}</td>
                            <td className="text-blue"> {item?.email}</td>
                            <td className="text-blue"> {item?.phone}</td>
                            <td className="text-blue">{item.account_no}</td>
                            <td className="text-blue">{item?.address}</td>
                            <td className="text-blue">{item?.zip_code}</td>
                            <td className="text-blue">
                              {item?.service_type_code}
                            </td>
                            <td className="text-blue">{item?.community}</td>

                            <td className="">
                              <button
                                className="btn btn-custom startlit_navy"
                                onClick={() => handlePasswordModalOpen(item)}
                                disabled={commonList?.length === 0}
                              >
                                Reset password
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card-footer d-flex flex-wrap align-items-center justify-content-between bg-white">
              {page.totalCount > 0 && (
                <Pagination page={page} setPage={setPage} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouteAccessCheck(ManageUser);
